export default "__VITE_ASSET__a52c8b94__"